<template>
    <div>
        <CompassDropdown
            :modelValue="modelValue"
            :loading="loading"
            :minWidth="minWidth"
            :parentRef="parentRef"
            :isVisible="isVisible"
            :dropdownClass="dropdownClass"
            multiple
        >
            <slot></slot>
        </CompassDropdown>
    </div>
</template>

<script>
export default {
    name: 'EmailInputDropdown',
    inheritAttrs: false,
    props: {
        modelValue: {
            type: [Array],
            default: () => [],
        },
        minWidth: {
            type: Number,
            default: 0,
        },
        isVisible: {
            type: Boolean,
            default: false,
        },
        dropdownClass: {
            type: String,
            default: '',
        },
        parentRef: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            popperInstance: null,
            hash: crypto.randomUUID(),
            isWaitingForMoreOptions: false,
        };
    },
};
</script>

<style lang="scss" scoped>
.email-input__dropdown {
    z-index: 1000;
    :deep(.compass-dropdown__footer-container) {
        display: none;
    }
}
</style>
